import { createContext, useContext } from 'react';
import { TenantWorkspaceRouteScope } from '../tenantWorkspace';

export interface WorkerProfileScope {
  workspace?: TenantWorkspaceRouteScope;
  companyId: number;
  workerId: number;
  basePath: string;
  returnTo?: string;
  revision?: number;
  data: {
    user: any;
    jobs: any[];
    documents: any[];
    credentials: any[];
    categories: any[];
    chats: any[];
    rating: any;
  };
}
export const WorkerProfileContext = createContext<WorkerProfileScope | null>(
  null
);
export const useWorkerProfile = () => useContext(WorkerProfileContext);
export const legacyProfileResponse = (data: unknown) =>
  Promise.resolve({ data: { data } });

export const workerRosterReturnTo = (
  companyId: number,
  value: unknown
): string => {
  const fallback = `/companies/${companyId}/workers`;
  if (
    typeof value !== 'string' ||
    !value.startsWith('/') ||
    value.startsWith('//')
  )
    return fallback;
  try {
    const parsed = new URL(value, 'https://workspace.invalid');
    return parsed.origin === 'https://workspace.invalid' &&
      [fallback, `${fallback}/blocked`].includes(parsed.pathname)
      ? `${parsed.pathname}${parsed.search}`
      : fallback;
  } catch {
    return fallback;
  }
};
